import React from 'react';
import { ArrowRightIcon, FileTextIcon, ZapIcon, MapIcon, ShieldCheckIcon, LockIcon, CreditCardIcon, BookOpenIcon, StarIcon } from 'lucide-react';
export function HeroSection() {
  const scrollToOffer = () => {
    const element = document.getElementById('oferta');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section id="hero" className="relative flex items-center justify-center overflow-hidden pt-16 sm:pt-20 pb-4 sm:pb-10 bg-transparent" data-id="element-113">
      <div className="relative z-10 max-w-3xl mx-auto px-3 sm:px-6 text-center flex flex-col items-center" data-id="element-114">
        <h1 className="text-[1.4rem] sm:text-4xl md:text-5xl font-black text-white leading-tight mb-1 tracking-tight" data-id="element-115">
          Ya arrancó el año. ¿Todavía estás armando clases{' '}
          <span className="text-[#D4A843] italic" data-id="element-116">desde cero?</span>
        </h1>

        <div className="w-full max-w-xs sm:max-w-lg md:max-w-xl my-3 sm:my-6 cursor-pointer transform hover:scale-105 transition-transform duration-500" onClick={scrollToOffer} data-id="element-117">
          <img src="https://cdn.magicpatterns.com/uploads/4SGBKtYBU5JVJXtid656DM/mockups_lenguA_.png" alt="Kit Completo Lengua y Literatura Mockup" className="w-full h-auto drop-shadow-2xl" data-id="element-118" />
        </div>

        <p className="text-sm sm:text-base md:text-lg text-gray-300 max-w-2xl mx-auto mb-4 sm:mb-6 font-medium leading-relaxed" data-id="element-119">
          El kit que usan docentes de Lengua y Literatura en todo el país para{' '}
          <span className="font-bold text-white border-b-2 border-[#D4A843]" data-id="element-120">
            recuperar su tiempo y disfrutar dar clases.
          </span>
        </p>

        <div className="flex flex-wrap justify-center gap-1.5 sm:gap-3 mb-4 sm:mb-6 w-full" data-id="element-121">
          <div className="flex items-center bg-[#121008] px-2 sm:px-3 py-1 sm:py-1.5 rounded-full border border-[#D4A843]/30 shadow-sm flex-shrink-0" data-id="element-122">
            <FileTextIcon className="w-3 h-3 sm:w-4 sm:h-4 text-[#E8C547] mr-1" data-id="element-123" />
            <span className="text-[9px] sm:text-xs font-bold text-gray-200 whitespace-nowrap" data-id="element-124">
              100% PDF
            </span>
          </div>
          <div className="flex items-center bg-[#121008] px-2 sm:px-3 py-1 sm:py-1.5 rounded-full border border-[#D4A843]/30 shadow-sm flex-shrink-0" data-id="element-125">
            <ZapIcon className="w-3 h-3 sm:w-4 sm:h-4 text-[#E8C547] mr-1" data-id="element-126" />
            <span className="text-[9px] sm:text-xs font-bold text-gray-200 whitespace-nowrap" data-id="element-127">
              Acceso inmediato
            </span>
          </div>
          <div className="flex items-center bg-[#121008] px-2 sm:px-3 py-1 sm:py-1.5 rounded-full border border-[#D4A843]/30 shadow-sm flex-shrink-0" data-id="element-128">
            <BookOpenIcon className="w-3 h-3 sm:w-4 sm:h-4 text-[#E8C547] mr-1" data-id="element-129" />
            <span className="text-[9px] sm:text-xs font-bold text-gray-200 whitespace-nowrap" data-id="element-130">
              Secundaria
            </span>
          </div>
          <div className="flex items-center bg-[#121008] px-2 sm:px-3 py-1 sm:py-1.5 rounded-full border border-[#D4A843]/30 shadow-sm flex-shrink-0" data-id="element-131">
            <MapIcon className="w-3 h-3 sm:w-4 sm:h-4 text-[#E8C547] mr-1" data-id="element-132" />
            <span className="text-[9px] sm:text-xs font-bold text-gray-200 whitespace-nowrap" data-id="element-133">
              Currículo argentino
            </span>
          </div>
        </div>

        <button onClick={scrollToOffer} className="flex items-center justify-center bg-[#D4A843] hover:bg-[#B8922E] text-white text-base sm:text-xl font-black py-2.5 px-5 sm:px-8 rounded-lg shadow-[0_4px_14px_rgba(212,168,67,0.4)] transition-all transform hover:-translate-y-1 w-full sm:w-auto border-b-4 border-[#9A7B24] active:border-b-0 active:translate-y-0 uppercase tracking-wide animate-subtle-bounce mb-4" data-id="element-134">
          QUIERO MI KIT COMPLETO{' '}
          <ArrowRightIcon className="ml-2 h-5 w-5" strokeWidth={3} data-id="element-135" />
        </button>

        <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-5 mt-4 text-gray-400 text-[10px] sm:text-xs font-medium" data-id="element-136">
          <div className="flex items-center" data-id="element-137">
            <ShieldCheckIcon className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-[#3b82f6] mr-1.5" data-id="element-138" />
            <span data-id="element-139">Garantía 7 días sin preguntas</span>
          </div>
          <div className="flex items-center" data-id="element-140">
            <LockIcon className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-[#f59e0b] mr-1.5" data-id="element-141" />
            <span data-id="element-142">Pago 100% seguro</span>
          </div>
          <div className="flex items-center" data-id="element-143">
            <CreditCardIcon className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-[#3b82f6] mr-1.5" data-id="element-144" />
            <span data-id="element-145">Mercado Pago | Tarjeta | Transferencia</span>
          </div>
        </div>

        {/* Social Proof Strip */}
        <div className="flex items-center justify-center gap-3 mt-6 sm:mt-8" data-id="element-146">
          <div className="flex items-center -space-x-2.5" data-id="element-147">
            <img src="https://randomuser.me/api/portraits/women/44.jpg" alt="Docente" className="w-8 h-8 sm:w-10 sm:h-10 rounded-full border-2 border-[#0a0e1a] object-cover" data-id="element-148" />
            <img src="https://randomuser.me/api/portraits/women/68.jpg" alt="Docente" className="w-8 h-8 sm:w-10 sm:h-10 rounded-full border-2 border-[#0a0e1a] object-cover" data-id="element-149" />
            <img src="https://randomuser.me/api/portraits/women/65.jpg" alt="Docente" className="w-8 h-8 sm:w-10 sm:h-10 rounded-full border-2 border-[#0a0e1a] object-cover" data-id="element-150" />
            <img src="https://randomuser.me/api/portraits/women/50.jpg" alt="Docente" className="w-8 h-8 sm:w-10 sm:h-10 rounded-full border-2 border-[#0a0e1a] object-cover" data-id="element-151" />
            <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full border-2 border-[#0a0e1a] bg-[#D4A843] flex items-center justify-center text-white text-[10px] sm:text-xs font-bold" data-id="element-152">
              +
            </div>
          </div>
          <div className="text-left" data-id="element-153">
            <p className="text-white text-xs sm:text-sm font-bold leading-tight" data-id="element-154">
              +1.800 docentes arrancaron el año con el kit
            </p>
            <div className="flex items-center gap-0.5 mt-0.5" data-id="element-155">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-3 h-3 sm:w-3.5 sm:h-3.5 text-[#D4A843] fill-current" data-id="element-156" />)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}